<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ title }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="modal.dismiss('')"
  >
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <div class="onboarding-content">
    <form [formGroup]="productForm" novalidate>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="field1">Type</label>
            <ng-select [items]="pmsProductTypes" bindLabel="label" bindValue="value" formControlName="type">
            </ng-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="field1">Rate Plan Code</label>
            <input type="text" class="form-control" formControlName="codeName" />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="">{{ 'HotelReservations.MealPlan' | translate }}</label>
            <ng-select
              [items]="mealOptions"
              bindLabel="label"
              bindValue="value"
              placeholder="{{ 'HotelReservations.SelectMealPlan' | translate }}"
              formControlName="mealName"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Abbrechen</button>
  <button type="button" ngbAutofocus class="btn btn-primary" (click)="onConfirm()">{{ buttonText }}</button>
</div>
